<div>
    <div>
      <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada" />
      <!-- <p-multiSelect
        appendTo="body"
        [options]="instancias"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="instanciaSelecionada"
        dataKey="id"
        inputId="id"
        placeholder="Instância"
        emptyMessage="Nenhuma instância"
        (onChange)="onInstanciaChange($event)"
      >
      </p-multiSelect> -->
      <p-calendar
        class="ml-3"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        (onClose)="onDateChange($event)"
        placeholder="Período"
      />
      <input class="ml-3" [style]="{'width':'140px'}" pInputText type="text" [(ngModel)]="contrato" placeholder="Contrato RE">
      <p-button
        class="ml-3"

        pRipple
        icon="pi pi-arrow-down-right"
        label="Buscar PIMS"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="requisitaIntegracao()"
      ></p-button>
      <p-button
        class="ml-3"

        pRipple
        icon="pi pi-arrow-up-right"
        label="Enviar ERP"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="enviarERP()"
      ></p-button>
      <p-button
        class="ml-3"

        pRipple
        icon="pi pi-file-excel"
        label="Exportar"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="exportar()"
      ></p-button>

      <div class="mt-3">
        <p-table
          [value]="parcelas"
          dataKey="idContrato"
          [(selection)]="parcelasSelecionadas"
          #dtContratos
          [globalFilterFields]="['idContrato','instancia']"
          [paginator]="true"
          [rows]="100"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Registros Selecionados: {{ parcelasSelecionadas.length }} | Mostrando de {first} até {last} de {totalRecords} registros"
          [rowsPerPageOptions]="[20, 50, 100, 500, 1000]"
          [loading]="loading"
          styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
          [scrollable]="true"
          scrollHeight="40.5rem"
          [resizableColumns]="true"
          [tableStyle]="{
            'font-size': '.9rem',
            'font-weight': '400',
            'border-spacing': '0 0 !important',
            'border-colapse': 'separate'
          }"
          #dt
        >
        <ng-template pTemplate="caption">
          <div class="flex">

              <span class="p-input-icon-left ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" [(ngModel)]="termo" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
              </span>
          </div>
      </ng-template>

          <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>

              <th pSortableColumn="idContrato">
                Contrato <p-sortIcon field="idContrato"></p-sortIcon>
              </th>
              <th pSortableColumn="instancia">
                Instância <p-sortIcon field="instancia"></p-sortIcon>
              </th>
              <th pSortableColumn="idParcela">
                Parcela <p-sortIcon field="idParcela"></p-sortIcon>
              </th>
              <th pSortableColumn="dtHistorico">
                Data Histórico <p-sortIcon field="dtHistorico"></p-sortIcon>
              </th>
              <th pSortableColumn="dtPagto">
                Data Pagamento <p-sortIcon field="dtPagto"></p-sortIcon>
              </th>
              <th pSortableColumn="vlHistorico">
                Valor <p-sortIcon field="vlHistorico"></p-sortIcon>
              </th>
              <th pSortableColumn="canaMes">
                Cana Mês <p-sortIcon field="canaMes"></p-sortIcon>
              </th>
              <th pSortableColumn="indice">
                Índice <p-sortIcon field="indice"></p-sortIcon>
              </th>
              <th>
                Taxas
              </th>
              <th>
                Valor Líquido
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-parcela>
            <tr>
                <td>
                    <p-tableCheckbox [value]="parcela" />
                </td>
              <td>{{ parcela.idContrato }}</td>
              <td>{{ parcela.instancia }}</td>
              <td>{{ parcela.idParcela }}</td>
              <td>{{ parcela.dtHistorico | date : "dd/MM/yyyy" }}</td>
              <td>{{ parcela.dtPagto | date : "dd/MM/yyyy" }}</td>
              <td>{{ parcela.vlHistorico.toLocaleString("pt-BR", { style: "currency", currency: 'BRL'}) }}</td>
              <td>{{ parcela.canaMes.toLocaleString("pt-BR") }}</td>
              <td>{{ parcela.indice.toLocaleString("pt-BR") }}</td>
              <td>{{ totalValor(parcela).toLocaleString("pt-BR", { style: "currency", currency: 'BRL'}) }}</td>
              <td>{{ (parcela.vlHistorico - totalValor(parcela)).toLocaleString("pt-BR", { style: "currency", currency: 'BRL'}) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado</td>
          </ng-template>
        </p-table>
      </div>


    </div>
  </div>
